/* GLAZE METHOD — light interactions */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.gm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function routine(root) {
    (root || document).querySelectorAll('[data-gm-routine]').forEach(function (wrap) {
      if (wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var steps = wrap.querySelectorAll('.gm-step');
      var panels = wrap.querySelectorAll('.gm-stage__panel');
      function show(i) {
        steps.forEach(function (s, j) {
          var on = i === j;
          s.setAttribute('aria-current', on ? 'true' : 'false');
          var b = s.querySelector('button'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.classList.toggle('is-active', i === j); p.setAttribute('aria-hidden', i === j ? 'false' : 'true'); });
      }
      steps.forEach(function (s, i) {
        var b = s.querySelector('button');
        if (b) b.addEventListener('click', function () { show(i); });
      });
      show(0);
    });
  }

  /* Show the full menu row on tablets/desktops (Horizon falls back to the drawer on any touch screen) */
  function menuRow() {
    var h = document.querySelector('#header-component');
    if (!h) return;
    var want = window.innerWidth >= 1000 ? 'menu' : 'drawer';
    if (h.dataset.menuStyle !== want) h.dataset.menuStyle = want;
  }
  function watchMenu() {
    var h = document.querySelector('#header-component');
    if (!h) return;
    menuRow();
    new MutationObserver(menuRow).observe(h, { attributes: true, attributeFilter: ['data-menu-style'] });
    window.addEventListener('resize', menuRow);
  }

  function init(root) { reveal(root); routine(root); if (!root) watchMenu(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
